export default __webpack_public_path__ + "static/media/Vector.93ec7008.svg";